import React, { useState, useEffect, useRef } from 'react';
import SoccerAttributes from './SoccerAttributes';
import { SERVER_URL } from '../../../config';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const MySoccer = () => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = sessionStorage.getItem('player_token');
  const navigate = useNavigate();
   const soccerRef = useRef(null);

  const handleScroll = () => {
    soccerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
         const response = await axios.get(`${SERVER_URL}/api/v2/get-football-gen-report`, {
                    headers: { Authorization: `Bearer ${token}`, }
             });
         if (response.data.status) {
                    setApiData(response.data.data);
         }
        setLoading(false);
       } catch (err) {
           setError('Failed to fetch data');
        setLoading(false);
                console.error("Failed to fetch diet report.", err);
                if (err.response?.status === 403) {
                    toast.error(`${err?.response?.data?.error?.msg}`);
                    setTimeout(() => {
                        toast.dismiss()
                        navigate('/player/Login');
                    }, 1500);
                }
            }
    };
    fetchData();
  }, []);

      const downloadFile = async () => {
        const category = 'footballgen';
        try {
            const response = await axios.get(`${SERVER_URL}/api/v2/download-report/${category}`, {
                responseType: 'blob',
                headers: { Authorization: `Bearer ${token}` },
            });

            let fileName = `${category}_report.pdf`;
            const disposition = response.headers['content-disposition'];
            const matches = disposition && disposition.match(/filename="?(.+)"?/);
            if (matches && matches[1]) {
                fileName = matches[1];
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download failed:", error);
            const msg = error?.response?.data?.error?.msg || "Something went wrong.";
            console.error('API Error:', msg);

            if (
                msg.includes("expired") ||
                msg.includes("invalidated") ||
                msg.includes("Invalid token") ||
                msg.includes("token is required")
            ) {
                toast.error("Session expired. Redirecting to login...");
                setTimeout(() => {
                    navigate('/player/login');
                }, 2000);
            }
            toast.error("Failed to download report.");

        }
    };

  if (loading) return <div className="text-white">Loading...</div>;
  if (error) return <div className="text-white">{error}</div>;

  const positions = apiData.current_position_other_suitable_Positions || [];

  return (
    <div>
      <div className="w-full">
        <div className="flex justify-center items-center p-5 gap-5 rounded-xl">
          <div className="flex lg:flex-row flex-col items-start gap-8 pt-7 ">
            <div className="lg:w-[40%] relative mx-auto">
              <img src="/assets/others/soccer-field.svg" className="w-full h-full mx-auto" />
              {positions.map((pos, index) => (
                <div
                  key={index}
                  className={`absolute ${
                    pos.attribute === 'Central Defender'
                      ? 'top-[24%] left-[15%]'
                      : pos.attribute === 'Full-Back'
                      ? 'top-[32%] right-[20%]'
                      : 'top-[52%] left-1/2 -translate-x-1/2'
                  } flex ${pos.attribute === 'Central Defender' ? 'items-start' : 'flex-col items-center'}`}
                >
                  <div className="flex flex-col items-center">
                    <div className="w-1.5 h-7 bg-gradient-to-t from-[#FFC300] via-[#7EFF2D] to-[#17E9F0] rounded-full mb-2"></div>
                    <div className="font-semibold text-[10px] text-center">
                      {pos.attribute.split(' ').map((word, i) => (
                        <React.Fragment key={i}>
                          {word}
                          <br />
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  <div
                    className={`text-white text-sm ${
                      pos.attribute === 'Central Defender' ? 'mt-1 -translate-x-2 font-bold' : '-500 font-bold px-2 py-1 rounded'
                    }`}
                  >
                    {pos.percentage}%
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:w-[60%] space-y-6">
              <div className="text-white">
                <h1 className="text-2xl font-bold mb-4">Genetic Hotspot</h1>
                <div className="space-y-4">
                  {positions.map((pos, index) => (
                    <React.Fragment key={index}>
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-gray-300">{pos.attribute}</span>
                        <span className="text-white font-bold">{pos.percentage}%</span>
                      </div>
                      <div className="w-full h-3 bg-gray-700 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-[#00FF00] via-[#B94CF3] to-[#5C1FE2] rounded-full"
                          style={{ width: `${pos.percentage}%` }}
                        ></div>
                      </div>
                    </React.Fragment>
                  ))}
                </div>

                <button className="mt-6 text-white px-0.5 py-0.5 rounded-full border border-white flex items-center space-x-2 transition-all duration-200"
                onClick={() => downloadFile()}
                >
                  <span className="text-sm font-medium pl-3 pr-1 py-1">View Full Report</span>
                  <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                    <i className="fa-solid fa-arrow-right" style={{ color: '#5C1FE2' }}></i>
                  </div>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                {positions.map((pos, index) => (
                  <div
                    key={index}
                    className="bg-[#D9D9D92B] backdrop-blur-sm rounded-lg px-4 py-9 border border-gray-700/50 hover:border-gray-600/50 transition-all duration-200"
                  >
                    <h3 className="text-white text-center font-bold text-lg mb-2">{pos.attribute}</h3>
                    <p className="text-white text-center mt-4 text-sm leading-relaxed">
                      {pos.attribute === 'Central Defender'
                        ? 'Strong defensive instincts, good positioning, essential for leadership in the backline'
                        : pos.attribute === 'Full-Back'
                        ? 'Agility, ability to cover flanks, promising in supporting both defense and attack transitions'
                        : 'Tactical awareness, vision, and defensive discipline suitable for a deeper playmaking role'}
                    </p>
                  </div>
                ))}
              </div>

                    <div className="flex justify-end mt-12 cursor-pointer" onClick={handleScroll}>
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-arrow-down" style={{ color: '#5C1FE2' }}></i>
                  <span className="text-sm mt-1">Scroll Down</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div ref={soccerRef}>
        <SoccerAttributes apiData={apiData} />
      </div>
    </div>
  );
};

export default MySoccer;